import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

const DEFAULT_TITLE = 'Chicilon Media';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);
  private langChangeSub?: Subscription;

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(snapshot);

    this.langChangeSub?.unsubscribe();

    if (!titleKey) {
      this.title.setTitle(DEFAULT_TITLE);
      return;
    }

    this.setTranslatedTitle(titleKey);

    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.setTranslatedTitle(titleKey);
    });
  }

  private setTranslatedTitle(key: string): void {
    const translated = this.translate.instant(key);
    if (translated !== key) {
      this.title.setTitle(translated || DEFAULT_TITLE);
      return;
    }

    this.title.setTitle(this.isTranslationKey(key) ? DEFAULT_TITLE : key);
  }

  private isTranslationKey(value: string): boolean {
    return /^[A-Z0-9_-]+(?:\.[A-Z0-9_-]+)+$/.test(value);
  }
}
